import React, { Component } from 'react';
import Navbar from '../Navbar'
import { Input, Collapse, Alert, Row, Col, Card, Button, CardHeader, CardBody, Badge, Spinner, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import Select from 'react-select';

const { proxy } = require('../../ip_api.config')

class Film_DisplayProductByGroup extends Component {

    constructor(props) {
        super(props)
        this.state = {
            filesDisplay: [],
            filterList: [
                {
                    displayName: 'Item Number',
                    name: 'itemId',
                    value: '',
                    inputType: 'text',
                    option: '',
                },
                {
                    displayName: 'Product Name',
                    name: 'itemDesc',
                    value: '',
                    inputType: 'text',
                    option: '',
                },
                {
                    displayName: 'IBrand 1',
                    name: 'iBrand1',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
                {
                    displayName: 'IBrand 2',
                    name: 'iBrand2',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
                {
                    displayName: 'IBrand 3',
                    name: 'iBrand3',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
                {
                    displayName: 'Item G1',
                    name: 'itemG1',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
                {
                    displayName: 'Item G3',
                    name: 'itemG3',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
                {
                    displayName: 'Upload Content',
                    name: 'uploadContent',
                    value: '',
                    inputType: 'multiOption',
                    option: [],
                },
            ],
            productData: [],
            uploadContent: [],
            deleteList: [],
            customAlert: {
                open: false,
                messages: '',
                status: ''
            },
        }
    }

    componentDidMount() {
        this.get_G1Filter()
        this.get_Ibrand1Filter()
        this.get_uploadContentFilter({ userId: localStorage.getItem("ID_User") })
    }

    get_Ibrand1Filter = () => {
        let url = proxy.server + '/flim/getIbrand1Filter'
        fetch(url, {
            method: "POST",
            headers: {
            },
            body: {}
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let filterList = this.state.filterList
                let arr = []

                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.iBrand1Id, label: val.iBrand1Name })
                        })
                        filterList[2].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[2].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_Ibrand2Filter = (selected) => {
        let url = proxy.server + '/flim/getIbrand2Filter'
        fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ id: selected })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let filterList = this.state.filterList
                let arr = []

                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.iBrand2Id, label: val.iBrand2Name })
                        })
                        filterList[3].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[3].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_Ibrand3Filter = (selected) => {
        let url = proxy.server + '/flim/getIbrand3Filter'
        fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ id: selected })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let filterList = this.state.filterList
                let arr = []

                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.iBrand3Id, label: val.iBrand3Name })
                        })
                        filterList[4].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[4].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_G1Filter = () => {
        let url = proxy.server + '/flim/getG1Filter'
        fetch(url, {
            method: "POST",
            headers: {
            },
            body: {}
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let arr = []
                let filterList = this.state.filterList
                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.itemG1Id, label: val.itemG1Name })
                        })
                        filterList[5].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[5].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_G3Filter = (selected) => {
        let url = proxy.server + '/flim/getG3Filter'
        fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ id: selected })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let filterList = this.state.filterList
                let arr = []

                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.itemG3Id, label: val.itemG3Name })
                        })

                        filterList[6].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[6].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_uploadContentFilter = (data) => {
        let url = proxy.server + '/flim/getUploadByGroup'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_uploadByGroup]", responseJson)
                let arr = []
                let filterList = this.state.filterList
                switch (responseJson.status) {
                    case 200:
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.typeNo, label: val.label })
                        })

                        filterList[7].option = arr;
                        this.setState({ filterList: filterList })

                        break;
                    default:
                        filterList[7].option = [];
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_uploadByGroup = (data, whereGroup) => {
        let url = proxy.server + '/flim/getUploadByGroup'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_uploadByGroup]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        let files = {};
                        let collapseUploadList = [];
                        responseJson.result.forEach(item => {
                            collapseUploadList.push(false)
                            files[`${item.fieldName}`] = (item.inputType === 'textarea') ? "" : [];
                            item.dataCount = 0;
                        });

                        this.setState({ uploadContent: responseJson.result, files: files, collapseUploadList: collapseUploadList })

                        this.get_dataUploadedByOption(whereGroup)
                        break;
                    default: this.setState({ uploadContent: [] })
                }
            })
    }

    get_dataUploadedByOption = (whereGroup) => {
        let url = proxy.server + '/flim/getDataUploadedByOption'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(whereGroup)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_dataUploadedByItem]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        const { files } = this.state;
                        let filesCopy = files;
                        responseJson.result.forEach(item => {
                            for (let key in filesCopy) {
                                if (key === item.fieldName) {
                                    switch (item.inputType) {
                                        case 'file':
                                            item.fileName = item.value.substring((item.value.lastIndexOf('/') + 1));
                                            filesCopy[`${item.fieldName}`].push(item)
                                            break;
                                        case 'textarea':
                                            filesCopy[`${item.fieldName}`] = item.value
                                            break;
                                        case 'text':
                                            filesCopy[`${item.fieldName}`].push({ value: item.value, remark: item.remark })
                                            break;
                                    }
                                }
                            }
                            let uploadContent = this.state.uploadContent.slice();
                            for (let i = 0; i < uploadContent.length; i++) {

                                if (item.typeNo === uploadContent[i].typeNo) {
                                    uploadContent[i].dataCount++;
                                }
                            }
                        });
                        this.setState({ files: filesCopy })

                        break;
                    default:
                }
            })
    }

    renderType = (type, name) => {
        switch (type) {
            case 'textarea':
                return (
                    this.state.files[name] ?
                        <Input type="textarea" value={this.state.files[name]} disabled />
                        : ''
                )
            case 'text':
                return (
                    this.state.files[name].length > 0 &&
                    this.state.files[name].map((val, i) => {
                        return (
                            <div style={{ display: 'flex', marginBottom: '10px' }}>
                                <div className="col-md-6 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Link</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" value={val.value} disabled />
                                    </InputGroup>
                                </div> &nbsp;
                                <div className="col-md-6 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>หมายเหตุ</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" name={name} value={val.remark} disabled />
                                    </InputGroup>
                                </div>
                            </div>
                        )
                    })
                )
            case 'file':
                return (
                    <React.Fragment>
                        {
                            this.state.files[name] && this.state.files[name].map((val, i) => {
                                return (
                                    <div style={{ display: 'flex', margin: '5px' }} key={i}>
                                        <div style={{ flex: '1' }}>
                                            {
                                                val.typeName && val.typeName === 'IMAGE' ?
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={`${proxy.server}/${val.value}`} onClick={() => this.handleDisplayImg(`${proxy.server}/${val.value}`)} style={{ maxHeight: '70px', maxWidth: '70px', width: '70px', height: '70px', objectFit: 'cover', cursor: 'pointer' }} />
                                                        <span style={{ marginLeft: '5px' }}>{val.fileName}</span>
                                                    </div>
                                                    : val.typeName === 'FILE' &&
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div style={{ flex: '1' }}>
                                                            <span>{val.fileName}</span>
                                                        </div>
                                                        <a href={`${proxy.server}/${val.value}`}>
                                                            <Button color="info" >Download File</Button>
                                                        </a>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </React.Fragment>
                )
        }
    }

    collapseUploadList = (index) => {
        let collapseUploadList = this.state.collapseUploadList;
        collapseUploadList[index] = !collapseUploadList[index];
        this.setState({ collapseUploadList: collapseUploadList })
    }

    handleChangeFilter = (value, fieldName) => {

        console.log('object', value)

        let filterList = this.state.filterList.slice()
        switch (fieldName) {
            case 'iBrand1':
                filterList[3].value = ''
                filterList[4].value = ''
                filterList[3].option = [];
                filterList[4].option = [];
                this.get_Ibrand2Filter(value)
                break;
            case 'iBrand2':
                filterList[4].option = [];
                filterList[4].value = '';
                this.get_Ibrand3Filter(value)
                break;
            case 'itemG1':
                filterList[6].option = [];
                filterList[6].value = '';
                this.get_G3Filter(value)
                break;
        }

        filterList.map((val, i) => {
            if (val.name === fieldName) {
                if (value === null) {
                    // for uploadContent filter
                    value = []
                }
                val.value = value
            }
        })
        this.setState({ filterList: filterList })
    }

    handleSearchSubmit = () => {
        this.setState({ itemId: this.state.filterList })
        let whereGroup = {}
        let isSelectedOnce = false
        let uploadContentList = '';
        this.state.filterList.map((val, i) => {
            if (val.name === 'uploadContent') {
                val.value.length > 0 && val.value.map((item, index) => {
                    uploadContentList += index === 0 ? item.value : ',' + item.value;
                })
            } else {
                whereGroup[`${val.name}`] = val.value;
                if (val.value !== '') {
                    isSelectedOnce = true
                }
            }
        })

        console.log('object uploadContentList', uploadContentList)

        if (isSelectedOnce) {
            this.get_uploadByGroup({ userId: localStorage.getItem("ID_User"), typeNo: uploadContentList }, whereGroup)
        } else {
            alert('กรุณาเลือกอย่างน้อย 1 ตัวเลือก')
        }
    }

    handleDisplayImg = (src) => {
        let modal = document.getElementById("showImg");
        let modalImg = document.getElementById("imgContent");
        modal.style.display = "block";
        modalImg.src = src;
    }

    handleCloseDisplayImg = () => {
        let modal = document.getElementById("showImg");
        modal.style.display = "none";
    }

    render() {
        const { filterList } = this.state;

        return (
            <React.Fragment>
                <Navbar nav={'Flim'} menu={'Flim_ManageProductImage'} />
                <div style={{ padding: '10px' }}>
                    <Card style={{ margin: '10px' }}>
                        <CardHeader><i class="fa fa-info-circle fa-lg" aria-hidden="true"></i> ข้อมูลสินค้า</CardHeader>
                        <CardBody>
                            <div style={{ padding: '10px' }}>
                                <Row>
                                    {
                                        filterList.map((val, i) => {
                                            return (
                                                <Col xs="12" sm="6" md="6" style={{ padding: '5px' }}>
                                                    <Row>

                                                        <Col xs="12" sm="6" md="3" >{val.displayName}:</Col>
                                                        {
                                                            val.inputType === 'option' ?
                                                                <Col xs="12" sm="6" md="9" >
                                                                    <Select
                                                                        defaultValue={val.value}
                                                                        value={val.option.filter(option => option.value === val.value)}
                                                                        onChange={(e) => this.handleChangeFilter(e.value, val.name)}
                                                                        options={val.option}
                                                                        placeholder={'ค้นหา ' + val.displayName}
                                                                    />
                                                                </Col>
                                                                : val.inputType === 'multiOption' ?
                                                                    <Col xs="12" sm="6" md="9" >
                                                                        <Select
                                                                            defaultValue={val.value}
                                                                            isMulti
                                                                            options={val.option}
                                                                            withAll={true}
                                                                            closeMenuOnSelect={false}
                                                                            onChange={(e) => this.handleChangeFilter(e, val.name)}
                                                                            className="basic-multi-select"
                                                                            classNamePrefix="select"
                                                                        />
                                                                    </Col>
                                                                    :
                                                                    <Col xs="12" sm="6" md="9" >
                                                                        <Input placeholder={val.displayName} onChange={(e) => this.handleChangeFilter(e.target.value, val.name)} />
                                                                    </Col>
                                                        }
                                                    </Row>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                                <Row>
                                    <Col sm="12" md="12" style={{ padding: '20px 5px 5px 5px' }}>
                                        <div style={{ textAlign: 'end' }}>
                                            <Button color="primary" onClick={() => this.handleSearchSubmit()} ><i class="fa fa-search" aria-hidden="true"></i> Search</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                    <Card style={{ margin: '10px' }}>
                        <CardHeader><i class="fa fa-cloud-upload fa-lg" aria-hidden="true"></i> รายการอัปโหลดไฟล์</CardHeader>
                        <CardBody>
                            <React.Fragment>
                                <div style={{ padding: '10px' }}>
                                    <Row>
                                        {this.state.uploadContent.map((val, i) => {
                                            return (
                                                <Card style={{ margin: '10px', width: '100%' }}>
                                                    <CardHeader style={{ backgroundColor: 'rgba(0,0,0,0)', cursor: 'pointer' }} onClick={() => this.collapseUploadList(i)}>
                                                        <div style={{ display: 'flex' }} >
                                                            <span style={{ flex: '1' }}  >{val.label} <Badge color="warning">{val.dataCount > 0 && val.dataCount}</Badge></span>
                                                            <span><i class="fa fa-minus-square-o" aria-hidden="true"></i></span>
                                                        </div>
                                                    </CardHeader>
                                                    <Collapse isOpen={this.state.collapseUploadList[i]}>
                                                        <CardBody><Col sm="12" md="12" style={{ padding: '5px' }} key={i}>
                                                            <Row>
                                                                <Col sm="12" md="12">
                                                                    {this.renderType(val.inputType, val.fieldName, val.typeNo)}
                                                                </Col>
                                                            </Row>
                                                        </Col></CardBody>
                                                    </Collapse>
                                                </Card>
                                            )
                                        })}
                                    </Row>
                                </div>
                            </React.Fragment>
                            <CustomAlert open={this.state.customAlert.open} messages={this.state.customAlert.messages} status={this.state.customAlert.status} />
                        </CardBody>
                    </Card>
                </div>
                <div id="showImg" class="modal">
                    <span class="close" onClick={() => this.handleCloseDisplayImg()} >&times;</span>
                    <img class="modal-content" id="imgContent" />
                </div>
            </React.Fragment>
        );
    }
}

export default Film_DisplayProductByGroup;

function CustomAlert(props) {
    /* status => processing, success, warning, error */
    return (
        props.open && <Alert color={props.status === 'processing' ? 'secondary' : props.status}>
            {props.status === 'processing' && <Spinner size="sm" color="secondary" />} {props.messages}
        </Alert>
    )
}